import React from "react";
import { Box, Typography, Container, Card, CardContent, Chip } from "@mui/material";
import { keyframes } from "@mui/system";
import TempleHinduIcon from "@mui/icons-material/TempleHindu";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import CelebrationIcon from "@mui/icons-material/Celebration";
import LightModeIcon from "@mui/icons-material/LightMode";
import Banner from "../../assets/Gpouram2.jpg";

// Animations
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideInLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const slideInRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const float = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-15px);
  }
`;

const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

const glow = keyframes`
  0%, 100% {
    box-shadow: 0 0 20px rgba(217,119,6,0.3);
  }
  50% {
    box-shadow: 0 0 40px rgba(217,119,6,0.6), 0 0 60px rgba(217,119,6,0.4);
  }
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
`;

export default function FestivalPage() {
    const festivals = [
        {
            name: "தை மாத திருவிழா",
            date: "தை மாதம் - 7 ஆம் தேதி முதல் 17 ஆம் தேதி வரை",
            desc: "தை மாதத்தில் 7-ஆம் தேதி கொடியேற்றம் நடைபெறும். 18-ஆம் தேதி கொடி இறக்கம் நடைபெறும். இத்தினங்களில் 11 நாட்கள் திருவிழாக்கள் சிறப்பாக நடைபெறும், எல்லா நாட்களிலும் சிறப்பு அன்னதானம் நடைபெறும்",
            icon: <TempleHinduIcon sx={{ fontSize: 40 }} />,
            color: "linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)",
        },
        {
            name: "வைகாசி மாத திருவிழா",
            date: "வைகாசி மாதம் - 7 ஆம் தேதி முதல் 17 ஆம் தேதி வரை",
            desc: "வைகாசி மாதத்தில் 7-ஆம் தேதி கொடியேற்றமும் 18-ஆம் தேதி கொடி இறக்கமும் நடைபெறும், எல்லா நாட்களிலும் சிறப்பு அன்னதானம் நடைபெறும்",
            icon: <CelebrationIcon sx={{ fontSize: 40 }} />,
            color: "linear-gradient(135deg, #fb923c 0%, #f97316 100%)",
        },
        {
            name: "ஆவணி மாத திருவிழா",
            date: "ஆவணி மாதம் - 7 ஆம் தேதி முதல் 17 ஆம் தேதி வரை",
            desc: "ஆவணி மாதத்தில் 7-ஆம் தேதி கொடியேற்றமும் 18-ஆம் தேதி கொடி இறக்கமும் நடைபெறும், எல்லா நாட்களிலும் சிறப்பு அன்னதானம் நடைபெறும்",
            icon: <AutoAwesomeIcon sx={{ fontSize: 40 }} />,
            color: "linear-gradient(135deg, #ea580c 0%, #dc2626 100%)",
        },
        {
            name: "எல்லா திருவிழாக்களிலும் 11ஆம் நாள் விசேஷம்",
            date: "ஒவ்வொரு திருவிழாவிலும் 11ஆம் நாள்",
            desc: "எல்லா திருவிழாக்களிலும் 11ஆம் திருவிழா அன்று விசேஷமாக நடைபெறும். அன்று இரவு தெருவீதிஉலா நடைபெறும். சுவாமி வாகன பவனி வருவார்.  இரவு 7 மணிக்கு ஆரம்பமாகும். அப்போது எல்லா வீடுகளிலும் மக்கள் பழம், வெற்றிலை, பாக்கு, பன்னீர், பூ, வைத்து (சுருள் வைத்து) வணங்குவார்கள் மேலும் திருவிழா நடைபெறும் எல்லா நாட்களிலும் இரவு அன்னதானம் நடைபெறும், எல்லா நாட்களிலும் மூன்று வேளையும் சுவாமிக்கு சிறப்பு பணிவிடை நடைபெறும்",
            icon: <LightModeIcon sx={{ fontSize: 40 }} />,
            color: "linear-gradient(135deg, #d97706 0%, #f59e0b 100%)",
            featured: true,
        },
        {
            name: "ஆனி மாதம் திரு ஏடு வாசிப்பு திருவிழா ",
            date: "ஆனி மாதம் - 9 ஆம் தேதி",
            desc: "ஆனி மாதம் 9-ஆம் தேதி திருஏடு வாசிப்பு திருவிழா காலை 7 மணி முதல் நடைபெறும், ஏடு வாசிப்பு நிறைவு பெற்றவுடன் சிறப்பு அன்னதானம் நடைபெறும்",
            icon: <TempleHinduIcon sx={{ fontSize: 40 }} />,
            color: "linear-gradient(135deg, #fbbf24 0%, #fb923c 100%)",
        },
        {
            name: "ஆடி மாதம் சிறப்பு பட்டாபிஷேகம்",
            date: "ஆடி மாதம் - கடைசி ஞாயிற்றுக்கிழமை",
            desc: "ஆடி மாதம் கடைசி ஞாயிற்றுக்கிழமை சிறப்பு பட்டாபிஷேகம் மற்றும் சிறப்பு பணிவிடை நடைபெறும், சிறப்பு அன்னதானம் நடைபெறும்",
            icon: <AutoAwesomeIcon sx={{ fontSize: 40 }} />,
            color: "linear-gradient(135deg, #fb923c 0%, #d97706 100%)",
        },
        {
            name: "கார்த்திகை மாதம் சிறப்பு ",
            date: "கார்த்திகை மாதம் - கடைசி ஞாயிறு",
            desc: "கார்த்திகை மாதத்தின் கடைசி ஞாயிற்றுக்கிழமை  திருக்கல்யாண வைபவம் நடைபெறும். மதியம் அன்னதானம் நடைபெறும். இரவு 7.00 மணிக்கு தெருவீதிஉலா நடைபெறும். சுவாமி வாகன பவனி வருவார்.",
            icon: <CelebrationIcon sx={{ fontSize: 40 }} />,
            color: "linear-gradient(135deg, #f97316 0%, #ea580c 100%)",
        },
        {
            name: "மார்கழி மாதம்  சொர்க்கவாசல் திறப்பு",
            // date: "மார்கழி மாதம் - கடைசி ஞாயிறு",
            desc: "மார்கழி  மாதத்தின் வைகுண்ட ஏகாதசி அன்று அதிகாலை 5 மணிக்கு சொர்க்கவாசல் திறப்பு மற்றும் சிறப்பு பணிவிடை  நடைபெறும். ",
            icon: <CelebrationIcon sx={{ fontSize: 40 }} />,
            color: "linear-gradient(135deg, #f97316 0%, #ea580c 100%)",
        },

        // {
        //     name: "பங்குனி உத்திரம்",
        //     date: "மார்ச் 24, 2024",
        //     desc: "பங்குனி உத்திரத்தில் தெய்வீக திருமண உற்சவம் சிறப்பாக நடைபெறும். திருக்கல்யாண விழா மகிழ்ச்சியுடன் கொண்டாடப்படும், எல்லா நாட்களிலும் சிறப்பு அன்னதானம் நடைபெறும்",
        //     icon: <LightModeIcon sx={{ fontSize: 40 }} />,
        //     color: "linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)",
        // },
    ];

    return (
        <Box
            sx={{
                minHeight: "100vh",
                width: "100%",
                background: "linear-gradient(180deg, #fffbeb 0%, #fff7ed 50%, #ffedd5 100%)",
            }}
        >
            {/* Banner Section */}
            <Box
                sx={{
                    position: "relative",
                    width: "100%",
                    height: { xs: "280px", sm: "380px", md: "480px" },
                    overflow: "hidden",
                }}
            >
                <img
                    src={Banner}
                    alt="Festival Banner"
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center",
                    }}
                />
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        background: "linear-gradient(180deg, rgba(217,119,6,0.4) 0%, rgba(217,119,6,0.8) 100%)",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 2,
                    }}
                >
                    {/* Animated Temple Icon */}
                    <Box
                        sx={{
                            animation: `${float} 3s ease-in-out infinite`,
                        }}
                    >
                        <Box
                            sx={{
                                backgroundColor: "rgba(255,255,255,0.2)",
                                backdropFilter: "blur(10px)",
                                borderRadius: "50%",
                                p: 3,
                                border: "3px solid rgba(255,255,255,0.5)",
                                animation: `${glow} 2s ease-in-out infinite`,
                            }}
                        >
                            <TempleHinduIcon
                                sx={{
                                    fontSize: { xs: 60, md: 80 },
                                    color: "white",
                                }}
                            />
                        </Box>
                    </Box>

                    {/* Title */}
                    <Typography
                        variant="h2"
                        sx={{
                            color: "white",
                            fontWeight: 700,
                            textAlign: "center",
                            fontFamily: "serif",
                            fontSize: { xs: "2.5rem", md: "3.5rem" },
                            textShadow: "4px 4px 8px rgba(0,0,0,0.5)",
                            animation: `${fadeInUp} 1s ease-out`,
                        }}
                    >
                        திருவிழாக்கள்
                    </Typography>

                    {/* Subtitle */}
                    <Typography
                        sx={{
                            color: "white",
                            fontSize: { xs: "1rem", md: "1.25rem" },
                            fontFamily: "serif",
                            textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                            animation: `${fadeInUp} 1s ease-out 0.2s both`,
                        }}
                    >
                        வருடாந்திர சிறப்பு நிகழ்வுகள்
                    </Typography>
                </Box>
            </Box>

            {/* Festival Cards */}
            <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
                {/* Decorative Line */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        mb: 6,
                    }}
                >
                    <Box
                        sx={{
                            width: "100px",
                            height: "4px",
                            background: "linear-gradient(90deg, transparent, #d97706, transparent)",
                            borderRadius: "2px",
                            animation: `${shimmer} 3s infinite linear`,
                            backgroundSize: "1000px 100%",
                        }}
                    />
                </Box>

                <Box sx={{ display: "flex", flexDirection: "column", gap: 5 }}>
                    {festivals.map((festival, index) => (
                        <Card
                            key={index}
                            sx={{
                                background: festival.featured
                                    ? "linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%)"
                                    : "white",
                                borderRadius: "24px",
                                overflow: "visible",
                                position: "relative",
                                border: festival.featured ? "3px solid #fed7aa" : "2px solid #fef3c7",
                                boxShadow: festival.featured
                                    ? "0 20px 60px rgba(217,119,6,0.25)"
                                    : "0 10px 40px rgba(217,119,6,0.15)",
                                animation: `${index % 2 === 0 ? slideInLeft : slideInRight} 0.8s ease-out ${index * 0.15
                                    }s both`,
                                transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                                "&:hover": {
                                    transform: "translateY(-10px) scale(1.02)",
                                    boxShadow: "0 25px 70px rgba(217,119,6,0.35)",
                                },
                                ...(festival.featured && {
                                    "&::before": {
                                        content: '""',
                                        position: "absolute",
                                        top: 0,
                                        left: "-100%",
                                        width: "100%",
                                        height: "100%",
                                        background:
                                            "linear-gradient(90deg, transparent, rgba(255,255,255,0.5), transparent)",
                                        animation: `${shimmer} 3s infinite`,
                                    },
                                }),
                            }}
                        >
                            <CardContent sx={{ p: { xs: 3, md: 4 } }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        gap: 3,
                                        flexDirection: { xs: "column", sm: "row" },
                                        alignItems: { xs: "center", sm: "flex-start" },
                                    }}
                                >
                                    {/* Icon Section */}
                                    <Box
                                        sx={{
                                            background: festival.color,
                                            borderRadius: "20px",
                                            p: 2.5,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: "white",
                                            minWidth: "80px",
                                            minHeight: "80px",
                                            boxShadow: "0 8px 24px rgba(217,119,6,0.3)",
                                            animation: `${pulse} 2s ease-in-out infinite`,
                                            "&:hover": {
                                                animation: `${rotate} 1s linear infinite`,
                                            },
                                        }}
                                    >
                                        {festival.icon}
                                    </Box>

                                    {/* Content Section */}
                                    <Box sx={{ flex: 1, textAlign: { xs: "center", sm: "left" } }}>
                                        {/* Festival Name */}
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                                mb: 1.5,
                                                flexWrap: "wrap",
                                                justifyContent: { xs: "center", sm: "flex-start" },
                                            }}
                                        >
                                            <Typography
                                                variant="h5"
                                                sx={{
                                                    fontWeight: 700,
                                                    color: "#92400e",
                                                    fontFamily: "serif",
                                                    fontSize: { xs: "1.25rem", md: "1.5rem" },
                                                }}
                                            >
                                                {festival.name}
                                            </Typography>
                                            {festival.featured && (
                                                <Chip
                                                    label="சிறப்பு"
                                                    size="small"
                                                    sx={{
                                                        background: "linear-gradient(135deg, #d97706, #f59e0b)",
                                                        color: "white",
                                                        fontWeight: 600,
                                                        animation: `${pulse} 2s ease-in-out infinite`,
                                                    }}
                                                />
                                            )}
                                        </Box>

                                        {/* Date */}
                                        {festival?.data && <Box
                                            sx={{
                                                display: "inline-flex",
                                                alignItems: "center",
                                                gap: 1,
                                                backgroundColor: "#fef3c7",
                                                px: 2,
                                                py: 0.75,
                                                borderRadius: "20px",
                                                mb: 2,
                                                border: "1px solid #fcd34d",
                                            }}
                                        >
                                            <CalendarMonthIcon
                                                sx={{ color: "#d97706", fontSize: 20 }}
                                            />
                                            <Typography
                                                sx={{
                                                    color: "#92400e",
                                                    fontWeight: 600,
                                                    fontSize: "0.9rem",
                                                    fontFamily: "serif",
                                                }}
                                            >
                                                {festival.date}
                                            </Typography>
                                        </Box>}

                                        {/* Description */}
                                        <Typography
                                            sx={{
                                                color: "#78350f",
                                                fontSize: { xs: "0.95rem", md: "1.05rem" },
                                                lineHeight: 1.8,
                                                fontFamily: "serif",
                                            }}
                                        >
                                            {festival.desc}
                                        </Typography>

                                        {/* Decorative Stars */}
                                        <Box
                                            sx={{
                                                display: "flex",
                                                gap: 1,
                                                mt: 2,
                                                justifyContent: { xs: "center", sm: "flex-start" },
                                            }}
                                        >
                                            {[0, 1, 2].map((i) => (
                                                <AutoAwesomeIcon
                                                    key={i}
                                                    sx={{
                                                        color: "#fbbf24",
                                                        fontSize: 18,
                                                        animation: `${pulse} 1.5s ease-in-out infinite ${i * 0.3
                                                            }s`,
                                                    }}
                                                />
                                            ))}
                                        </Box>
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>
                    ))}
                </Box>

                {/* Bottom Decorative Element */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        mt: 8,
                        animation: `${fadeInUp} 1s ease-out 0.5s both`,
                    }}
                >
                    <Box
                        sx={{
                            textAlign: "center",
                            backgroundColor: "white",
                            px: 5,
                            py: 3,
                            borderRadius: "30px",
                            border: "2px solid #fed7aa",
                            boxShadow: "0 10px 40px rgba(217,119,6,0.15)",
                        }}
                    >
                        <Typography
                            sx={{
                                color: "#92400e",
                                fontWeight: 600,
                                fontFamily: "serif",
                                fontSize: "1.1rem",
                            }}
                        >
                            அனைத்து திருவிழாக்களிலும் பங்கேற்று வைகுண்ட நாராயணரின் அருளாசி  பெறுங்கள்
                        </Typography>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
}